// test600
(600 && 0);
